/**
 * Dr. Riva - Load More Button
 * AJAX pagination for mobile collection pages
 * Uses event delegation to survive AJAX section swaps
 */
(function() {
  'use strict';

  var BUTTON_SELECTOR = '[data-dr-component="loadMore"]';
  var originalText = 'עוד מוצרים';

  function handleLoadMore(btn) {
    var nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl || btn.classList.contains('is-loading')) return;

    // Show loading state
    btn.classList.add('is-loading');
    originalText = btn.textContent;
    btn.textContent = 'טוען...';

    fetch(nextUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Extract new product items from the fetched page
        var newItems = doc.querySelectorAll('#product-grid > li');
        var grid = document.querySelector('#product-grid');

        if (grid && newItems.length > 0) {
          newItems.forEach(function(item) {
            // Remove animation classes/styles that might interfere
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            item.removeAttribute('data-cascade');
            item.removeAttribute('style');
            grid.appendChild(item);
          });
        }

        // Check for next page in the fetched content
        var newLoadMoreBtn = doc.querySelector(BUTTON_SELECTOR);
        if (newLoadMoreBtn) {
          var newNextUrl = newLoadMoreBtn.getAttribute('data-next-url');
          if (newNextUrl) {
            btn.setAttribute('data-next-url', newNextUrl);
            btn.classList.remove('is-loading');
            btn.textContent = originalText;
          } else {
            // No more pages
            btn.style.display = 'none';
          }
        } else {
          // No more pages (button not present in response)
          btn.style.display = 'none';
        }
      })
      .catch(function(error) {
        console.error('Load more error:', error);
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
      });
  }

  // Event delegation: listener on document survives AJAX section swaps
  document.addEventListener('click', function(e) {
    var btn = e.target.closest(BUTTON_SELECTOR);
    if (!btn) return;
    
    e.preventDefault();
    handleLoadMore(btn);
  });
})();
